import type { ReactNode } from 'react';

export function humanize(str: string | undefined) {
  if (str == undefined) {
    return '';
  }
  var i,
    frags = str.split('_');
  for (i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1).toLowerCase();
  }
  return frags.join(' ');
}

export function isBlank(str: string | undefined): boolean {
  return !str || str.length == 0;
}

export function isBlankHtml(str: string | undefined): boolean {
  if (!str) {
    return true;
  }
  const doc = new DOMParser().parseFromString(str, 'text/html');
  return !doc.body.textContent || doc.body.textContent.length == 0;
}

export const ellipsis = (input: string, maxLength: number = 5) => (input.length > maxLength ? `${input.substring(0, maxLength)}...` : input);

/** "1 organisation", "3 organisations". Pass pluralWord for irregular plurals. */
export function plural(count: number, word: string, pluralWord = `${word}s`) {
  return `${count} ${count === 1 ? word : pluralWord}`;
}

/** Adds "..." to a text message, unless it already ends with "..." or "…". Other content is returned as is. */
export function withEllipsis(message: ReactNode): ReactNode {
  if (typeof message !== 'string' || message.endsWith('...') || message.endsWith('…')) {
    return message;
  }
  return message + '...';
}
